import {
  CompanyApi,
  UpdateCompanyDTO,
  UpdateCurrentCompanyDTO
} from '../api-client/generated/api';
import axiosInstance from './axios';

const apiCaller = new CompanyApi();

const getCurrentCompany = async () => {
  const { data } = await apiCaller.companyGetCurrentCompany();
  return data;
};

const updateCurrentCompany = async (
  url: string,
  params: UpdateCurrentCompanyDTO
) => {
  if (!params) {
    return null;
  }
  const { taxes: t } = params;
  // we build tax custom structure
  const taxes = t?.map((tax: any) => {
    return {
      id: tax?.id,
      name: tax?.name,
      tax: tax?.tax,
      type: tax?.type
    };
  });
  const { status, statusText } = await apiCaller.companyUpdateCurrentCompany({
    updateCurrentCompanyDTO: {
      ...params,
      taxes
    }
  });

  return { status, statusText };
};

const deleteTax = async (id: string) => {
  const { data } = await apiCaller.companyDeleteTaxById({ id });
  return data;
};

const getCompanies = async () => {
  const response = await apiCaller.companyGetAll();
  return response.data;
};

const companyArchiveCompany = async (params: any) => {
  const { id } = params;
  const response = await apiCaller.companyArchiveCompany({ id });
  return { data: response.data, status: response.status };
};

const companyUnarchiveCompany = async (params: any) => {
  const { id } = params;
  const response = await apiCaller.companyUnarchiveCompany({ id });
  return { data: response.data, status: response.status };
};

const updateCompanyById = async (id: string, params: UpdateCompanyDTO) => {
  if (!params) {
    return null;
  }
  const { widgetsAllowed, plan } = params;
  const { calculatorV3Enabled } = params as any;
  const { data } = await apiCaller.companyUpdateOneById({
    id,
    updateCompanyDTO: { plan, widgetsAllowed, calculatorV3Enabled } as any
  });

  return { data };
};

const getSystemTaxes = async () => {
  const { data } = await axiosInstance.get('/company/system/taxes');
  return data;
};

const createSystemTax = async (tax: {
  name: string;
  tax: number;
  type: string;
}) => {
  const { data } = await axiosInstance.post('/company/system/taxes', tax);
  return data;
};

const updateSystemTax = async (
  id: string,
  tax: { name: string; tax: number; type: string }
) => {
  const { data } = await axiosInstance.patch(
    `/company/system/taxes/${id}`,
    tax
  );
  return data;
};

const deleteSystemTax = async (id: string) => {
  await axiosInstance.delete(`/company/system/taxes/${id}`);
};

export default {
  companyArchiveCompany,
  companyUnarchiveCompany,
  createSystemTax,
  deleteTax,
  deleteSystemTax,
  getCompanies,
  getCurrentCompany,
  getSystemTaxes,
  updateCompanyById,
  updateCurrentCompany,
  updateSystemTax
};
